import axios from "axios";

const api = axios.create({
  baseURL: process.env.GATSBY_API_MEU_PERFIL_URL,
});

const meuPerfilApi = {
  makeThematicRegistration: async (token, temaId) => {
    try {
      await api.post(
        "/inscricoes-tematicas",
        { temaId },
        { headers: { authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.log('error', error);
      return error;
    }
  },
  saveInterestInTheme: async (token, payload) => {
    try {
      return await api.post(
        "/inscricoes-tematicas/interesse-tema",
        payload,
        { headers: { authorization: `Bearer ${token}` } } 
      ).then(res => {return res})
    } catch (error) {
      console.log('error', error);
      return error;
    }
  },
  getInterestInTheme: async (token, themeId) => {
    try {
      return await api.get(
       `/inscricoes-tematicas?temaId=${themeId}`,
        { headers: { authorization: `Bearer ${token}` } } 
      ).then(res => {return res})
    } catch (error) {
      console.log('error', error);
      return error;
    }
  },
  saveDownloadContent: async (token, payload) => {
    try {
      return await api.post(
        "/save-download/save-content",
        payload,
        { headers: { authorization: `Bearer ${token}` } } 
      ).then(res => {return res})
    } catch (error) {
      console.log('error', error);
      return error;
    }
  },
  savePrintContent: async (token, payload) => {
    try {
      return await api.post(
        "/save-print/save-content",
        payload,
        { headers: { authorization: `Bearer ${token}` } } 
      ).then(res => {return res})
    } catch (error) {
      console.log('error', error);
      return error;
    }
  },
};

export { meuPerfilApi };
